import React from "react";

type PageTitleProps = {
  title: string;
};

export function PageTitle({ title }: PageTitleProps) {
  return (
    <div className="PageTitle">
      <div className="PageTitle__title text-collins-heading">{title}</div>
    </div>
  );
}
